.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
  font-size: var(--icon-size, 1em);
  color: var(--icon-color, currentColor);
}
